(function () {
  function updateProgress(swiper, progressEl) {
    if (!progressEl) return;
    var slides = swiper.slides ? swiper.slides.length : 1;
    var perView = typeof swiper.params.slidesPerView === "number" ? swiper.params.slidesPerView : 1;
    var maxIndex = Math.max(slides - perView, 1);
    var percent = Math.min(((swiper.realIndex || swiper.activeIndex || 0) + 1) / (maxIndex + 1), 1) * 100;
    progressEl.style.setProperty("--progress-width", percent + "%");
  }

  function initSwiper(root, name, options) {
    root.querySelectorAll('[data-swiper="' + name + '"]').forEach(function (el) {
      if (el.dataset.pdPdpReady === "true") return;
      el.dataset.pdPdpReady = "true";
      var progress = root.querySelector('[data-pd-swiper-progress="' + name + '"]');

      if (window.Swiper) {
        new window.Swiper(el, Object.assign({}, options, {
          on: {
            init: function (swiper) { updateProgress(swiper, progress); },
            slideChange: function (swiper) { updateProgress(swiper, progress); },
            resize: function (swiper) { updateProgress(swiper, progress); }
          }
        }));
        return;
      }

      var wrapper = el.querySelector(".swiper-wrapper");
      if (!wrapper) return;
      el.classList.add("is-native-swiper");
      var slides = Array.prototype.slice.call(wrapper.querySelectorAll(".swiper-slide"));
      slides.forEach(function (slide) { slide.style.scrollSnapAlign = "start"; });

      function nativeIndex() {
        if (!slides.length) return 0;
        var currentLeft = el.scrollLeft;
        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - currentLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      }

      function setNativeProgress() {
        if (!progress) return;
        var count = Math.max(slides.length, 1);
        var percent = Math.min(((nativeIndex() + 1) / count) * 100, 100);
        progress.style.setProperty("--progress-width", percent + "%");
      }

      var isDragging = false;
      var startX = 0;
      var startScrollLeft = 0;
      var moved = false;
      var startIndex = 0;
      var dragDelta = 0;

      function eventX(event) {
        if (event.touches && event.touches.length) return event.touches[0].clientX;
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
        return event.clientX || 0;
      }

      function startDrag(event) {
        if (event.button !== undefined && event.button !== 0) return;
        isDragging = true;
        moved = false;
        startX = eventX(event);
        startScrollLeft = el.scrollLeft;
        startIndex = nativeIndex();
        dragDelta = 0;
        el.classList.add("is-native-swiper-dragging");
        if (event.pointerId !== undefined && el.setPointerCapture) el.setPointerCapture(event.pointerId);
      }

      function moveDrag(event) {
        if (!isDragging) return;
        var delta = eventX(event) - startX;
        dragDelta = delta;
        if (Math.abs(delta) > 3) moved = true;
        if (moved && event.cancelable) event.preventDefault();
        el.scrollLeft = startScrollLeft - delta;
        window.requestAnimationFrame(setNativeProgress);
      }

      function stopDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        el.classList.remove("is-native-swiper-dragging");
        if (event && event.pointerId !== undefined && el.releasePointerCapture) {
          try { el.releasePointerCapture(event.pointerId); } catch (error) {}
        }
        if (moved && Math.abs(dragDelta) > 24 && slides.length) {
          var targetIndex = startIndex + (dragDelta < 0 ? 1 : -1);
          targetIndex = Math.max(0, Math.min(targetIndex, slides.length - 1));
          el.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: "smooth" });
        }
        window.requestAnimationFrame(setNativeProgress);
      }

      el.addEventListener("pointerdown", startDrag);
      el.addEventListener("pointermove", moveDrag);
      el.addEventListener("pointerup", stopDrag);
      el.addEventListener("pointercancel", stopDrag);
      el.addEventListener("pointerleave", stopDrag);
      el.addEventListener("mousedown", startDrag);
      window.addEventListener("mousemove", moveDrag);
      window.addEventListener("mouseup", stopDrag);
      el.addEventListener("touchstart", startDrag, { passive: true });
      el.addEventListener("touchmove", moveDrag, { passive: false });
      el.addEventListener("touchend", stopDrag);
      el.addEventListener("touchcancel", stopDrag);
      el.addEventListener("click", function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      el.addEventListener("scroll", function () { window.requestAnimationFrame(setNativeProgress); }, { passive: true });
      window.addEventListener("resize", setNativeProgress);
      setNativeProgress();
    });
  }

  function initAccordions(root) {
    root.querySelectorAll(".pd-pdp-accordion button").forEach(function (button) {
      if (button.dataset.pdPdpAccordionReady === "true") return;
      button.dataset.pdPdpAccordionReady = "true";
      button.addEventListener("click", function () {
        var expanded = button.getAttribute("aria-expanded") === "true";
        var panel = button.nextElementSibling;
        button.setAttribute("aria-expanded", String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function initModal(root) {
    var modal = root.querySelector("[data-pdp-notify-modal]");
    if (modal && modal.querySelector("[data-pdp-notify-result]") && !modal.open) {
      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");
    }
    var notifyForm = modal && modal.querySelector("form");
    if (notifyForm && notifyForm.dataset.pdNotifyReady !== "true") {
      notifyForm.dataset.pdNotifyReady = "true";
      notifyForm.addEventListener("submit", function () {
        var submitButton = notifyForm.querySelector('button[type="submit"]');
        notifyForm.setAttribute("aria-busy", "true");
        if (submitButton) {
          submitButton.textContent = "Enviando...";
          submitButton.disabled = true;
        }
      });
    }
    root.querySelectorAll("[data-open-pdp-notify]").forEach(function (button) {
      if (button.dataset.pdPdpModalReady === "true") return;
      button.dataset.pdPdpModalReady = "true";
      button.addEventListener("click", function () {
        if (modal && typeof modal.showModal === "function") modal.showModal();
        else if (modal) modal.setAttribute("open", "");
      });
    });
    root.querySelectorAll("[data-close-pdp-notify]").forEach(function (button) {
      if (button.dataset.pdPdpCloseReady === "true") return;
      button.dataset.pdPdpCloseReady = "true";
      button.addEventListener("click", function () {
        if (modal && typeof modal.close === "function") modal.close();
        else if (modal) modal.removeAttribute("open");
      });
    });
  }

  function formatMoney(value) {
    var number = Number(value || 0);
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  async function fetchShippingRates(form, zip) {
    var country = form.dataset.shippingCountry || "Brazil";
    var province = form.dataset.shippingProvince || "";
    var params = new URLSearchParams();
    params.set("shipping_address[zip]", zip);
    params.set("shipping_address[country]", country);
    if (province) params.set("shipping_address[province]", province);

    var response = await fetch("/cart/shipping_rates.json?" + params.toString(), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });

    if (!response.ok) {
      var prepare = await fetch("/cart/prepare_shipping_rates.json?" + params.toString(), {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });
      if (!prepare.ok && prepare.status !== 202) throw new Error("shipping-unavailable");
      await new Promise(function (resolve) { window.setTimeout(resolve, 900); });
      response = await fetch("/cart/async_shipping_rates.json?" + params.toString(), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });
    }

    if (!response.ok) throw new Error("shipping-unavailable");
    return response.json();
  }

  function initShipping(root) {
    root.querySelectorAll("[data-pdp-shipping-form]").forEach(function (form) {
      if (form.dataset.pdPdpShippingReady === "true") return;
      form.dataset.pdPdpShippingReady = "true";
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        var input = form.querySelector("input");
        var result = form.querySelector("[data-pdp-shipping-result]");
        var button = form.querySelector("button");
        var zip = input ? input.value.replace(/\D/g, "") : "";

        if (!result) return;
        result.classList.remove("is-error", "is-success");
        if (zip.length < 8) {
          result.textContent = "Digite um CEP valido com 8 digitos.";
          result.classList.add("is-error");
          return;
        }

        result.textContent = "Calculando frete...";
        if (button) button.disabled = true;

        try {
          var data = await fetchShippingRates(form, zip);
          var rates = data.shipping_rates || [];
          if (!rates.length) {
            result.textContent = "Adicione o produto ao carrinho para calcular o frete deste CEP.";
            result.classList.add("is-error");
            return;
          }

          var cheapest = rates.slice().sort(function (a, b) {
            return Number(a.price || 0) - Number(b.price || 0);
          })[0];
          result.textContent = cheapest.name + ": " + formatMoney(cheapest.price);
          result.classList.add("is-success");
        } catch (error) {
          result.textContent = "Nao foi possivel calcular agora. Confira o CEP ou tente pelo carrinho.";
          result.classList.add("is-error");
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  }

  function initPdp(root) {
    root = root || document;
    initSwiper(root, "pdp-gallery", {
      slidesPerView: 1.08,
      spaceBetween: 12,
      watchOverflow: true,
      breakpoints: { 768: { slidesPerView: 1, spaceBetween: 0 } }
    });
    initSwiper(root, "pdp-how", {
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: true,
      watchOverflow: true,
      breakpoints: { 768: { slidesPerView: 3, spaceBetween: 0, allowTouchMove: false } }
    });
    initSwiper(root, "pdp-botanicals", {
      slidesPerView: 1.08,
      spaceBetween: 28,
      watchOverflow: true,
      breakpoints: { 768: { slidesPerView: 3, spaceBetween: 24, allowTouchMove: false } }
    });
    initAccordions(root);
    initModal(root);
    initShipping(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initPdp(document); });
  } else {
    initPdp(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initPdp(event.target);
  });
})();
